import React, { ElementType } from 'react'
import { cn } from 'cn'
import Link from 'next/link'
import useTheme from 'lib/theme/useTheme'

type MenuItemProps = {
  title?: string
  href: string
  Icon?: ElementType
  transparentHeader?: boolean
  titleClassName?: string
  onClick?: React.MouseEventHandler
}

const MenuItem = React.forwardRef<HTMLAnchorElement, MenuItemProps>(
  (
    {
      title,
      href,
      Icon,
      transparentHeader,
      titleClassName,
      onClick
    }: MenuItemProps,
    ref
  ) => {
    const { theme } = useTheme()
    const themedHeader = theme.page.themedBackground

    return (
      <Link
        ref={ref}
        className={cn({
          'text-white font-theme-body font-semibold px-5 py-2.5 rounded-theme-button transition bg-theme-button hover:bg-theme-button-hover':
            themedHeader,
          'group flex items-center cursor-pointer whitespace-nowrap transition duration-50 ease-in-out font-heading font-bold':
            !themedHeader,
          'hover:text-gray-50': !themedHeader && transparentHeader,
          'text-gray-900 hover:text-orange-600':
            !themedHeader && !transparentHeader
        })}
        href={href}
        onClick={onClick}
        prefetch={false}
      >
        {Icon && (
          <Icon
            className={cn('mr-0.5 xl:mr-2 md:h-4 md:w-4 h-5 w-5', {
              'group-hover:text-gray-50': transparentHeader,
              'text-gray-900 group-hover:text-orange-600':
                !transparentHeader && !themedHeader
            })}
          />
        )}
        {title && <span className={cn(titleClassName)}>{title}</span>}
      </Link>
    )
  }
)

MenuItem.displayName = 'MenuItem'

export default MenuItem
